import {createWebHashHistory, createRouter} from "vue-router";

import HomePage from "@/components/HomePage.vue";
import DailyParking from "@/components/parking/DailyParking.vue";
import PrintReceipt from "../../public/PrintDocs/Receipts/PrintReceipt.vue";
import CreateBusiness from "@/components/sbp/CreateBusiness";
import BusinessPayment from "@/components/sbp/BusinessPayment";
import HouseRents from "@/components/rent/HouseRents";
import PrintPermit from "@/components/sbp/PrintPermit";
import VerifySchool from "@/components/education/VerifySchool.vue";
import Permit from "../../public/PrintDocs/permit/Permit";
import LandRate from "@/components/landrate/LandRate";
import PublicDemandNotice from "@/components/landrate/PublicDemandNotice.vue";
import PayBill from "@/components/paybill/PayBill";

// Property Services Components
import PropertySelfService from "@/components/valuation/PropertySelfService.vue";
import PropertySearch from "@/components/valuation/PropertySearch.vue";
import PropertyUpdateForm from "@/components/valuation/PropertyUpdateForm.vue";
import PropertyVerification from "@/components/valuation/PropertyVerification.vue";
import SubmissionSuccess from "@/components/valuation/SubmissionSuccess.vue";

// General Pages
import HowItWorks from "@/components/HowItWorks.vue";
import Services from "@/components/Services.vue";
import PrintReceiptPage from "@/components/PrintReceiptPage.vue";
import BuildingPermits from "@/components/building/BuildingPermits.vue";
import Contact from "@/components/Contact.vue";
import HealthCertificates from "@/components/health/HealthCertificates.vue";
import WasteManagement from "@/components/utilities/WasteManagement.vue";
import WaterServices from "@/components/utilities/WaterServices.vue";
import Overview from "@/components/Overview.vue";
import Payment from "@/components/Payment.vue";
import LandSearch from "@/components/landrate/LandSearch.vue";
import FAQ from "@/components/FAQ.vue";
import LiveChat from "@/components/LiveChat.vue";
import ApplicationAcknowledgment from "@/components/building/ApplicationAcknowledgment.vue";
import TrackApplication from "@/components/building/TrackApplication.vue";
import Bill from "../../public/PrintDocs/Bill/Bill.vue";
import FireLicensing from "@/components/fire/FireLicensing.vue";
import PrintFireLicense from "@/components/fire/PrintFireLicense.vue";
import FirePermit from "../../public/PrintDocs/FireCertificate/FirePermit.vue";
import PrintFoodHygieneLicence from "@/components/health/PrintFoodHygieneLicence.vue";
import HealthPermit from "../../public/PrintDocs/hygene/HealthPermit.vue";
import LiquorLicense from "@/components/liquor/LiquorLicense.vue";
import PrintLiquorLicense from "@/components/liquor/PrintLiquorLicense.vue";
import LiquorPermit from "../../public/Alcohol/LiquorPermit.vue";
import TrackLiquorApplication from "@/components/liquor/TrackLiquorApplication.vue";
import TrackMedicalApplication from "@/components/medical/TrackMedicalApplication.vue";
import PrintMedicalCertificate from "@/components/medical/PrintMedicalCertificate.vue";
import MedicalCertificate from "../../public/PrintDocs/healthCertificates/MedicalCertificate.vue";

const routes = [
    // ===== HOME =====
    {
        path: "/",
        name: "HomePage",
        component: HomePage,
        meta: { public: true }
    },
    {
        path: "/overview",
        name: "overview",
        component: Overview,
        meta: { public: true }
    },

    // ===== BUSINESS PERMIT =====
    {
        path: "/create-business",
        name: "create-business",
        component: CreateBusiness,
        meta: { public: true }
    },
    {
        path: "/sbp-payment",
        name: "business-payment",
        component: BusinessPayment,
        meta: { public: true }
    },

    {
        path: "/print-permit/:businessID?",
        name: "print-permit",
        component: PrintPermit,
        meta: { public: true }
    },

    // Public school-certificate verification page. Hit by the QR on every
    // education certificate — the URL is encoded into the QR by the cert
    // template (PrintDocs/schools/certificate.html).
    {
        path: "/verify-school/:registrationNo?",
        name: "verify-school",
        component: VerifySchool,
        meta: { public: true }
    },



    {
        path: "/permit/:businessID?",
        name: "permit",
        component: Permit,
        meta: { public: true }
    },

    // ===== LAND RATES =====
    {
        path: "/land-rate",
        name: "land-rate",
        component: LandRate,
        meta: { public: true }
    },
    {
        path: "/land-rates",
        name: "land-rates",
        component: LandRate,
        meta: { public: true }
    },
    {
        path: "/land-search",
        name: "land-search",
        component: LandSearch,
        meta: { public: true }
    },
    {
        path: "/demand-notice",
        name: "demand-notice",
        component: PublicDemandNotice,
        meta: { public: true }
    },

    // ===== PARKING =====
    {
        path: "/daily-parking",
        name: "DailyParking",
        component: DailyParking,
        meta: { public: true }
    },
    {
        path: "/seasonal-parking",
        name: "seasonal-parking",
        component: DailyParking,
        meta: { public: true }
    },

    // ===== RENTS =====
    {
        path: "/house-rents",
        name: "house-rents",
        component: HouseRents,
        meta: { public: true }
    },
    {
        path: "/market-stalls",
        name: "market-stalls",
        component: HouseRents,
        meta: { public: true }
    },

    // ===== PAYMENTS & BILLS =====

    {
        path: '/bill',
        name: 'bill',
        component: Bill,
        meta:{public: false}
    },

    {
        path: "/pay-bill",
        name: "pay-bill",
        component: PayBill,
        meta: { public: true }
    },

    {
        path: "/payment/:billNo?",
        name: "payment",
        component: Payment,
        meta: { public: true }
    },

    // ===== RECEIPTS =====
    {
        path: "/print-receipt",
        name: "print-receipt",
        component: PrintReceiptPage,
        meta: { public: true }
    },
    {
        path: "/receipt/:receiptNo?",
        name: "receipt",
        component: PrintReceipt,
        meta: { public: true }
    },

    // ===== BUILDING & CONSTRUCTION =====
    {
        path: "/building-permits",
        name: "building-permits",
        component: BuildingPermits,
        meta: { public: true }
    },
    {
        path: '/application-acknowledgment',
        name: 'ApplicationAcknowledgment',
        component: ApplicationAcknowledgment,
        meta: { public: true }
    },

    {
        path: '/track-application/:applicationNumber?',
        name: 'TrackApplication',
        component: TrackApplication,
        meta: { public: true }
    },

    {
        path:"/health-permit",
        name:"health-permit",
        component: HealthPermit,
        meta:{public: true}
    },

    // ===== HEALTH =====
    {
        path: "/health-certificates",
        name: "health-certificates",
        component: HealthCertificates,
        meta: { public: true }
    },

    // router
    {
        path: '/health/print-food-hygiene-licence/:businessID?',
        name: 'print-food-hygiene-licence',
        component: PrintFoodHygieneLicence,
        meta: { public: true }
    },

    // ===== FIRE =====
    {
        path: "/fire-license",
        name: "fire-license",
        component: FireLicensing,
        meta: { public: true }
    },

  {
        path: "/print-fire-license",
        name: "print-fire-license",
        component: PrintFireLicense,
        meta: { public: true }
    },

     {
        path: "/fire-certificate/:businessID?",
        name: "fire-certificate",
        component: FirePermit,
        meta: { public: true }
    },

    {
        path: "/liquor-certificate",
        name: "liquor-certificate",
        component: LiquorPermit,
        meta: { public: true }
    },

    {
        path: "/track-liquor-application",
        name: "track-liquor-application",
        component: TrackLiquorApplication,
        meta: { public: true },
        props: route => ({
            businessID: route.query.businessID || route.query.businessId || route.query.id,
            billNo: route.query.billNo || route.query.bill,
            phone: route.query.phone || route.query.phoneNumber
        })
    },


    {
        path: "/print-liquor-license",
        name: "print-liquor-license",
        component: PrintLiquorLicense,
        meta: { public: true },
        props: route => ({
            businessID: route.query.businessID || route.query.businessId || route.query.id,
            billNo: route.query.billNo || route.query.bill,
            phone: route.query.phone || route.query.phoneNumber
        })
    },


    // ===== MEDICAL CERTIFICATE =====
    {
        path: "/print-medical-certificate",
        name: "print-medical-certificate",
        component: PrintMedicalCertificate,
        meta: { public: true },
        props: route => ({
            idNo: route.query.idNo || route.query.id,
            billNo: route.query.billNo || route.query.bill,
            phone: route.query.phone || route.query.phoneNumber
        })
    },
    {
        path: "/track-medical-application",
        name: "track-medical-application",
        component: TrackMedicalApplication,
        meta: { public: true },
        props: route => ({
            idNo: route.query.idNo || route.query.id,
            billNo: route.query.billNo || route.query.bill,
            phone: route.query.phone || route.query.phoneNumber
        })
    },

    {
        path: "/medical-certificate/:idNo?",
        name: "medical-certificate",
        component: MedicalCertificate,
        meta: { public: true }
    },


    {
        path: "/liquor-license",
        name: "liquor-license",
        component: LiquorLicense,
        meta: { public: true }
    },

    // ===== UTILITIES =====
    {
        path: "/water-services",
        name: "water-services",
        component: WaterServices,
        meta: { public: true }
    },
    {
        path: "/waste-management",
        name: "waste-management",
        component: WasteManagement,
        meta: { public: true }
    },

    // ===== PROPERTY SERVICES =====
    {
        path: "/property-self-service",
        name: "property-self-service",
        component: PropertySelfService,
        meta: { public: true }
    },
    {
        path: "/property-search",
        name: "property-search",
        component: PropertySearch,
        meta: { public: true }
    },
    {
        path: "/property-valuation",
        name: "property-valuation",
        component: PropertySelfService,
        meta: { public: true }
    },
    {
        path: "/property-update",
        name: "property-update",
        component: PropertyUpdateForm,
        meta: { public: true }
    },
    {
        path: "/property-verification",
        name: "property-verification",
        component: PropertyVerification,
        meta: { public: true }
    },
    {
        path: "/submission-success",
        name: "submission-success",
        component: SubmissionSuccess,
        meta: { public: true }
    },

    // ===== FIRE INSPECTION CERTIFICATE =====
    {
        path: "/print-fire-certificate",
        name: "print-fire-certificate",
        component: () => import("@/components/fire/PrintFireCertificate.vue"),
        meta: { public: true },
        props: route => ({
            businessId: route.query.businessId || route.query.businessID || route.query.id,
            billNo: route.query.billNo || route.query.bill,
            phone: route.query.phone || route.query.phoneNumber
        })
    },
    {
        path: "/track-fire-application",
        name: "track-fire-application",
        component: () => import("@/components/fire/TrackFireApplication.vue"),
        meta: { public: true },
        props: route => ({
            businessId: route.query.businessId || route.query.businessID || route.query.id,
            billNo: route.query.billNo || route.query.bill,
            phone: route.query.phone || route.query.phoneNumber
        })
    },


    // ===== INFORMATION PAGES =====
    {
        path: "/how-it-works",
        name: "how-it-works",
        component: HowItWorks,
        meta: { public: true }
    },
    {
        path: "/services",
        name: "services",
        component: Services,
        meta: { public: true }
    },

    {
        path: "/contact",
        name: "contact",
        component: Contact,
        meta: { public: true }
    },
    {
        path: "/faq",
        name: "faq",
        component: FAQ,
        meta: { public: true }
    },
    {
        path: "/live-chat",
        name: "live-chat",
        component: LiveChat,
        meta: { public: true }
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Always scroll to top when navigating
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    }
});

export default router;